'use strict';

/**
 * @description Dashboard Component
 * @returns {Object} Devuelve la instancia del componente
 */

import i18n from 'i18next';
import moment from 'moment-timezone';
import { store } from '../../app.init.js';
import { API_URL } from '../../environment.json';
import { componentDocumentList } from '../../shared/components/document-list/document-list.component.js';
import { componentLayoutExtended } from '../../shared/components/layoutExtended/layoutExtended.component.js';
import { templateShareModal } from '../../shared/components/modal/modalShare.template.js';
import { componentRapidAccess } from '../../shared/components/rapid-access/rapid-access.component.js';
import { componentToolbar } from '../../shared/components/toolbar/toolbar.component.js';
import { dateSetTime } from '../../utils/dateFormat.js';
import { rendernoPeninsulares } from './noPeninsulares.renders.js';
import { servicesnoPeninsulares } from './noPeninsulares.services.js';
import { templatenoPeninsulares } from './noPeninsulares.template.js';

let componentnoPeninsulares = (function () {
  let context = {};
  let filterForm = {
    ambit: '',
    category: '',
    process: '',
    action: '',
    query: '',
  };
  let renderSuccess = false;
  let canaryNumbers;
  let melillaNumbers;
  let balearNumbers;
  let ceutaNumbers;
  let erniNumbers;
  let snpMoreData;
  let modalText;
  let snpData;
  let titles;
  let geoidactual = 8743;
  let currentDate = moment().format('YYYY-MM-DD');
  let melillaFormatComparisonDate = null;
  let tenerifeLaGomeraComparisonDate = null;
  let today;
  let showTenGomLink = false;
  let buttonsState = [];

  const ERNI_GEOIDS = {
    TAB1: 8743,
    TAB2: 8742,
    TAB3: 8795,
    TAB4: 8797,
    TAB5: 8796,
    TAB6: 8798,
    TAB7: 8799,
    TAB8: 8800,
    TAB9: 8831,
  };

  const ERNI_TAB_MAPPING = {
    TAB1: { widget: 'widget42', spinner: 'spinner42' },
    TAB2: { widget: 'widget43', spinner: 'spinner43' },
    TAB3: { widget: 'widget44', spinner: 'spinner44' },
    TAB4: { widget: 'widget45', spinner: 'spinner45' },
    TAB5: { widget: 'widget49', spinner: 'spinner49' },
    TAB6: { widget: 'widget47', spinner: 'spinner47' },
    TAB7: { widget: 'widget48', spinner: 'spinner48' },
    TAB8: { widget: 'widget50', spinner: 'spinner50' },
    TAB9: { widget: 'widget51', spinner: 'spinner51' },
  };

  const widgetToTab = Object.fromEntries(
    Object.entries(ERNI_TAB_MAPPING).map(([tab, { widget }]) => [widget, tab])
  );
  const tabRequestVersion = Object.fromEntries(
    Object.keys(ERNI_TAB_MAPPING).map((tab) => [tab, 0])
  );
  const ERNI_WIDGET_DEFAULT_DAY = '15';
  const WIDGET_15_INDICATORS_IGNORED_FOR_DATE_CHECK = new Set([
    570, 572, 578, 579,
  ]);

  const getDateFromQuery = () => {
    const queryParams = new URLSearchParams(window.location.search);
    const queryDate = queryParams.get('date');
    if (!queryDate) return null;

    const parsedQueryDate = moment(queryDate, 'DD-MM-YYYY', true);
    return parsedQueryDate.isValid() ? parsedQueryDate : null;
  };

  const getErniEmbedSlug = () => {
    const lang = store.getState().exampleReducer.currentLang;
    return lang === 'es'
      ? 'porcentaje-de-energia'
      : 'percentage-of-renewable-energy';
  };

  const getErniShareParams = (geoId) => {
    const params = new URLSearchParams(window.location.search);
    params.set('geo_id', geoId);
    return `?${params.toString()}`;
  };

  const getSelectedDateValue = () =>
    document.getElementById('datepicker')?.value ||
    moment().format('DD / MM / YYYY');

  const getErniAnalysisUrl = (geoId) => {
    const selectedDate = getSelectedDateValue();
    const endDate = moment(selectedDate, 'DD / MM / YYYY').format('DD-MM-YYYY');
    const startDate = moment(endDate, 'DD-MM-YYYY')
      .subtract(14, 'months')
      .format('DD-MM-YYYY');
    if (geoId === 8743) {
      return `/${i18n.t('routes.lng')}/${i18n.t(
        'routes.analysis'
      )}/10488?compare_indicators=10489,10490&start_date=${startDate}T00%3A00&end_date=${endDate}T23%3A55&geoids=${geoId}`;
    }
    return `/${i18n.t('routes.lng')}/${i18n.t(
      'routes.analysis'
    )}/10489?compare_indicators=10488,10490&start_date=${startDate}T00%3A00&end_date=${endDate}T23%3A55&geoids=${geoId}`;
  };

  const buildErniAnalysisUrl = (startDate, endDate, geoId) => {
    if (geoId === 8743) {
      return `/${i18n.t('routes.lng')}/${i18n.t(
        'routes.analysis'
      )}/10488?compare_indicators=10489,10490&start_date=${startDate}T00%3A00&end_date=${endDate}T23%3A55&geoids=${geoId}`;
    }
    return `/${i18n.t('routes.lng')}/${i18n.t(
      'routes.analysis'
    )}/10489?compare_indicators=10488,10490&start_date=${startDate}T00%3A00&end_date=${endDate}T23%3A55&geoids=${geoId}`;
  };

  const erniModalText = `<div class="esios-noPeninsulares__title">
      <h1>${i18n.t('erniSNP')}</h1>
    </div>
    <p>La programación de la generación en los sistemas no peninsulares se hace en base a un despacho económico que tiene en cuenta los costes reconocidos de los grupos de generación, de manera que la demanda de energía es cubierta por aquellos grupos que supongan un menor coste para el sistema.</p>
    <p>La retribución de los grupos de generación en los sistemas no peninsulares se calcula en base a unos costes variables y unos costes fijos, cuyos parámetros son verificados por el Operador del Sistema y reconocidos por el Ministerio competente.</p>`;

  let setInfoArr = [
    {
      id: 1,
      array: balearNumbers,
      slug: 'baleares',
    },
    {
      id: 2,
      array: canaryNumbers,
      slug: 'canarias',
    },
    {
      id: 3,
      array: ceutaNumbers,
      slug: 'ceuta',
    },
    {
      id: 4,
      array: melillaNumbers,
      slug: 'melilla',
    },
    {
      id: 5,
      array: erniNumbers,
      slug: 'erniSNP',
    },
  ];

  let obToolbar = [];

  let documents = [
    {
      title: 'Informe incidente Tenerife 15 julio 2020',
      link: '/es/documentacion/informe-incidente-tenerife-15-julio-2020',
    },
    {
      title: 'Informe Incidente Tenerife 29 septiembre 2019',
      link: '/es/documentacion/informe-incidente-tenerife-29-septiembre-2019',
    },
    {
      title:
        'Intercambio de Información con el OS Vol.4 Extrapeninsulares v1.0.13',
      link: '/es/documentacion/intercambio-de-informacion-con-el-os-extrapeninsulares',
    },
    {
      title:
        'P.O. 2.3: Programación del intercambio de energía por el enlace eléctrico entre el sistema eléctrico balear y el sistema eléctrico peninsular',
      link: '/es/documentacion/p-o-2-3-programacion-del-intercambio-de-energia-por-el-enlace-electrico-entre-el-sistema-electrico-balear-y-el-sistema-electrico-peninsular',
    },
  ];

  const setInfoModalArr = (array) => {
    array.forEach((arr, index) => {
      setInfoArr[index].array = arr;
    });
  };

  const setDateTimeForGeoID = (id, data) => {
    let dateInput = document.querySelector(`.esios-noPeninsulares__date.${id}`);
    const dataWithRelevantDate =
      id === 'melilla' && Array.isArray(data)
        ? data.filter(
            (indicator) =>
              !WIDGET_15_INDICATORS_IGNORED_FOR_DATE_CHECK.has(
                Number(indicator?.id)
              )
          )
        : data;
    const datetime = Array.isArray(dataWithRelevantDate)
      ? dataWithRelevantDate
          .flatMap((indicator) => [
            indicator?.datetime,
            ...(indicator?.print_values || []).map((value) => value?.datetime),
          ])
          .find((value) => value && moment(value).isValid())
      : null;

    if (dateInput) {
      dateInput.innerText = datetime
        ? moment(datetime).tz('Europe/Madrid').format('DD / MM / YYYY')
        : '-- / -- / --';
    }
  };

  const setInfoModal = (
    id,
    data,
    modalData,
    html,
    updateShareModal = 'all'
  ) => {
    if (updateShareModal !== 'share') {
      obToolbar[id - 1].textModal = `<div class="esios-noPeninsulares__title">
      <h1>${i18n.t(modalData.slug).toUpperCase()}</h1>
    </div>
     ${modalData.modalText == null ? null : modalData.modalText}`;
    }
    obToolbar[id - 1].widgetData = {
      slug: modalData.slug,
      indicators: data,
    };
    obToolbar[id - 1].shareModal = html;
  };

  const setTabButtonsLocked = (locked) => {
    document.querySelectorAll('.tablinkssnp').forEach((btn) => {
      btn.style.pointerEvents = locked ? 'none' : '';
      btn.style.opacity = locked ? '0.6' : '';
    });
    document
      .querySelectorAll(
        '.esios-toolbar16 .esios-toolbar__buttons, .esios-toolbar16 .esios-toolbar__items'
      )
      .forEach((el) => {
        el.style.pointerEvents = locked ? 'none' : '';
      });
    const toolbar16 = document.querySelector('.esios-toolbar16');
    if (toolbar16) {
      toolbar16.style.opacity = locked ? '0.6' : '';
    }
  };

  const setLoadingForTab = async (targetTab, isLoading) => {
    const mapping = ERNI_TAB_MAPPING[targetTab];
    if (!mapping) {
      return;
    }

    const widget = document.getElementById(mapping.widget);
    const spinner = document.getElementById(mapping.spinner);

    if (!widget || !spinner) {
      return;
    }

    const isActiveTab =
      document
        .querySelector(`.tablinkssnp[data-tab-target="${targetTab}"]`)
        ?.classList.contains('active') ?? false;

    if (isLoading) {
      widget.style.display = 'block';
      widget.style.visibility = 'hidden';
      spinner.style.display = 'flex';
      if (isActiveTab) setTabButtonsLocked(true);

      melillaFormatComparisonDate = null;
      try {
        const validUntilDateCeuta =
          await servicesnoPeninsulares.getGeolocalizationDate(8744);
        if (validUntilDateCeuta) {
          melillaFormatComparisonDate =
            moment(validUntilDateCeuta).format('YYYY-MM-DD');
        }
      } catch (error) {
        console.error(
          'Error obteniendo la fecha de geolocalización de Ceuta:',
          error
        );
      }

      tenerifeLaGomeraComparisonDate = null;
      try {
        const validUntilDate =
          await servicesnoPeninsulares.getGeolocalizationDate(8797);
        if (validUntilDate) {
          tenerifeLaGomeraComparisonDate =
            moment(validUntilDate).format('YYYY-MM-DD');
        }
      } catch (error) {
        console.error(
          'Error obteniendo la fecha de geolocalización de Tenerife:',
          error
        );
      }
    } else {
      spinner.style.display = 'none';
      widget.style.display = 'block';
      widget.style.visibility = 'visible';
      if (isActiveTab) setTabButtonsLocked(false);
    }
  };

  const createTabRequestToken = (targetTab) => {
    tabRequestVersion[targetTab] = (tabRequestVersion[targetTab] || 0) + 1;
    return tabRequestVersion[targetTab];
  };

  const isLatestTabRequest = (targetTab, requestToken) =>
    tabRequestVersion[targetTab] === requestToken;

  const updateErniToolbar = (geoId, indicators = erniNumbers, data) => {
    const erniToolbar = obToolbar[4];
    if (!erniToolbar) {
      return;
    }

    geoidactual = geoId;
    erniToolbar.params = `geo_id=${geoId}`;
    erniToolbar.printParams = `paramWidgetId=43&widgetType=graph&geo_id=${geoId}`;
    erniToolbar.url = () => getErniAnalysisUrl(geoId);

    const modalData = {
      modalText: data?.description ?? null,
      slug: data?.slug ?? '',
    };

    setInfoModal(
      5,
      indicators,
      modalData,
      templateShareModal(getErniEmbedSlug(), getErniShareParams(geoId), true, {
        height: 414,
        width: '100%',
      })
    );

    componentToolbar.render(erniToolbar, '.esios-toolbar16');
  };

  const fetchAndRenderErniWidget = async ({
    widgetId,
    geoId,
    fecha,
    targetTab,
    requestToken,
  }) => {
    const inputCalendar = document.querySelector('#datepicker');
    const widgetNumber = widgetId.replace('widget', '');
    const graphId = `mypGraphic${widgetNumber}`;
    const noDataGraphicId = `mypNoDataRect${widgetNumber}`;

    try {
      const data = await servicesnoPeninsulares.getErniDataFromWidget({
        lang: store.getState().exampleReducer.currentLang,
        ...fecha,
        widgetId,
      });

      if (!data || !isLatestTabRequest(targetTab, requestToken)) {
        return;
      }

      // Calcular qué mes va a mostrar el gráfico como último.
      // Reglas:
      // - Si effectiveDate cae en el mes actual del sistema => a mes vencido (mes anterior).
      // - Si ese mes (mes vencido) no tiene datos para ESTE geo_id => bajar 1 mes más.
      // Importante: siempre se comprueba con indicadores filtrados por geo_id para evitar
      // mezclar datos entre tabs.
      const effectiveMoment = moment(
        data.effectiveDate,
        'DD-MM-YYYY',
        true
      ).startOf('month');
      const nowMoment = moment().tz('Europe/Madrid').startOf('month');

      let indicatorsForGeo = (
        Array.isArray(data?.indicators) ? data.indicators : []
      ).filter((ind) => Number(ind?.geo_id) === Number(geoId));

      const hasValuesForMonth = (m, aditionalData = null) => {
        const monthStr = moment(m).format('YYYY-MM');

        if (aditionalData) {
          // Fusionar SOLO datos del mismo geo_id y SOLO indicadores ERNI SNP (10488/10489/10490)
          const geoIdRef =
            indicatorsForGeo[0]?.geo_id ??
            (Array.isArray(aditionalData) ? aditionalData[0]?.geo_id : null);

          const filteredAditionalData = (
            Array.isArray(aditionalData) ? aditionalData : []
          ).filter(
            (ind) =>
              Number(ind?.geo_id) === Number(geoIdRef) &&
              [10488, 10489, 10490].includes(Number(ind?.id))
          );

          const merged = indicatorsForGeo
            .concat(filteredAditionalData)
            .filter((ind) => [10488, 10489, 10490].includes(Number(ind?.id)));

          // Unificar valores por indicador (si hay dos 10488 con ventanas temporales distintas,
          // combinamos values sin duplicados por mes).
          const mergedByIndicator = new Map();
          merged.forEach((ind) => {
            const key = `${Number(ind?.geo_id)}|${Number(ind?.id)}`;
            const existing = mergedByIndicator.get(key);

            const incomingValues = Array.isArray(ind?.values) ? ind.values : [];
            const normalizedIncoming = incomingValues
              .map((v) => {
                const rawDate = v?.x ?? v?.datetime;
                const monthKey = v?.monthKey ?? (moment(rawDate).isValid()
                  ? moment(rawDate)
                      .tz('Europe/Madrid')
                      .startOf('month')
                      .format('YYYY-MM')
                  : null);
                if (!monthKey) return null;
                return { ...v, __monthKey: monthKey };
              })
              .filter(Boolean);

            if (!existing) {
              // Clonar indicador + normalizar values deduplicados por mes (último gana)
              const mapVals = new Map(
                normalizedIncoming.map((v) => [v.__monthKey, v])
              );
              mergedByIndicator.set(key, {
                ...ind,
                values: Array.from(mapVals.values())
                  .map(({ __monthKey, ...rest }) => rest)
                  .sort((a, b) => {
                    const da = moment(a?.x ?? a?.datetime);
                    const db = moment(b?.x ?? b?.datetime);
                    return da.valueOf() - db.valueOf();
                  }),
              });
              return;
            }

            const existingValues = Array.isArray(existing?.values)
              ? existing.values
              : [];
            const normalizedExisting = existingValues
              .map((v) => {
                const rawDate = v?.x ?? v?.datetime;
                const monthKey = v?.monthKey ?? (moment(rawDate).isValid()
                  ? moment(rawDate)
                      .tz('Europe/Madrid')
                      .startOf('month')
                      .format('YYYY-MM')
                  : null);
                if (!monthKey) return null;
                return { ...v, __monthKey: monthKey };
              })
              .filter(Boolean);

            const mapVals = new Map(
              normalizedExisting.map((v) => [v.__monthKey, v])
            );
            normalizedIncoming.forEach((v) => {
              // Regla: si el mes existe, preferimos el que tenga dato no-null; si ambos, el último mergeado.
              const prev = mapVals.get(v.__monthKey);
              const prevVal = prev?.y ?? prev?.value ?? null;
              const nextVal = v?.y ?? v?.value ?? null;
              if (prev == null || prevVal == null || nextVal != null) {
                mapVals.set(v.__monthKey, v);
              }
            });

            mergedByIndicator.set(key, {
              ...existing,
              ...ind,
              values: Array.from(mapVals.values())
                .map(({ __monthKey, ...rest }) => rest)
                .sort((a, b) => {
                  const da = moment(a?.x ?? a?.datetime);
                  const db = moment(b?.x ?? b?.datetime);
                  return da.valueOf() - db.valueOf();
                }),
            });
          });

          indicatorsForGeo = Array.from(mergedByIndicator.values());
        }

        const filteredIndicatorsForGeo = indicatorsForGeo.filter((ind) =>
          [10488, 10489, 10490].includes(Number(ind?.id))
        );
        const coincidences = filteredIndicatorsForGeo.some((ind) => {
          const values = Array.isArray(ind?.values) ? ind.values : [];
          return values.some((v) => {
            const yVal = v?.y ?? v?.value ?? null;
            if (yVal == null) return false;
            const vMonthStr = v?.monthKey ?? (moment(v?.x).isValid()
              ? moment(v.x).format('YYYY-MM')
              : v?.datetime && moment(v.datetime).isValid()
              ? moment(v.datetime).format('YYYY-MM')
              : null);
            return vMonthStr === monthStr;
          });
        });
        return { coincidences, indicatorsForGeo };
      };

      let chartEndMoment = moment(effectiveMoment);
      if (
        effectiveMoment.isValid() &&
        effectiveMoment.isSame(nowMoment, 'month')
      ) {
        const prevMonth = moment(effectiveMoment).subtract(1, 'month');
        chartEndMoment = prevMonth;

        // Si el mes vencido no tiene datos, bajamos un mes más.
        if (!hasValuesForMonth(prevMonth).coincidences) {
          chartEndMoment = moment(effectiveMoment).subtract(1, 'month');
        }
      }

      // Si chartEndMoment sigue sin datos, reintentamos con el mes anterior
      // (máximo 1 reintento para evitar bucles infinitos).
      if (!hasValuesForMonth(chartEndMoment).coincidences) {
        const retryMoment = moment(chartEndMoment).subtract(1, 'month');
        const retryFecha = {
          day: ERNI_WIDGET_DEFAULT_DAY,
          month: retryMoment.format('MM'),
          year: retryMoment.format('YYYY'),
        };
        const retryData = await servicesnoPeninsulares.getErniDataFromWidget({
          lang: store.getState().exampleReducer.currentLang,
          ...retryFecha,
          widgetId,
        });
        if (retryData && isLatestTabRequest(targetTab, requestToken)) {
          Object.assign(data, retryData);
          indicatorsForGeo = hasValuesForMonth(
            chartEndMoment,
            retryData.indicators
          ).indicatorsForGeo;
        }
      }

      const date = (data?.effectiveDate || inputCalendar.value).replace(
        /\s*\/\s*/g,
        '-'
      );
      const filteredIndicators = indicatorsForGeo.filter((indicator) =>
        [10488, 10489, 10490].includes(Number(indicator?.id))
      );

      // Solo TAB9 tiene datos de geo_id 8831 (Tenerife/La Gomera combinado).
      // Actualizar showTenGomLink desde otras tabs resetearía el flag incorrectamente.
      if (widgetId === ERNI_TAB_MAPPING.TAB9.widget) {
        const previousShowTenGomLinkVal =
          typeof structuredClone === 'function'
            ? structuredClone(showTenGomLink)
            : showTenGomLink;
        showTenGomLink = data?.indicators?.some(
          (indicator) => indicator?.geo_id === 8831 && indicator?.id === 10488
        );

        if (showTenGomLink !== previousShowTenGomLinkVal) {
          // Capturar la tab activa antes de que renderBaseTemplate elimine el botón.
          const prevActiveTab =
            document
              .querySelector('.tablinkssnp.active')
              ?.getAttribute('data-tab-target') || null;

          renderBaseTemplate(buttonsState, showTenGomLink);

          const activeButton =
            document.querySelector('.tablinkssnp.active') ||
            document.querySelector('.tablinkssnp[data-tab-target="TAB1"]');
          const tabToShow =
            activeButton?.getAttribute('data-tab-target') || 'TAB1';
          tabsReset(tabToShow);

          // Si TAB4 o TAB7 desaparecen al aparecer TAB9, cargar TAB1.
          if (
            showTenGomLink &&
            (prevActiveTab === 'TAB4' || prevActiveTab === 'TAB7')
          ) {
            loadTabById('TAB1');
          }
        }
      }

      document.getElementById(widgetId)?.querySelector('svg')?.remove();
      updateErniToolbar(geoId, filteredIndicators, data);

      await rendernoPeninsulares.renderErniWidget(
        {
          ...data,
          indicators: filteredIndicators,
        },
        date,
        graphId,
        noDataGraphicId,
        `#${graphId}`,
        true,
        data.indicators,
        chartEndMoment
      );
    } finally {
      if (!isLatestTabRequest(targetTab, requestToken)) {
        return;
      }

      const tab = widgetToTab[widgetId];
      if (tab) {
        setLoadingForTab(tab, false);
      }
    }
  };

  const loadTabById = (targetTab, fechaOpcional) => {
    const mapping = ERNI_TAB_MAPPING[targetTab];
    if (!mapping) {
      return;
    }

    const fechaBase =
      fechaOpcional ||
      (() => {
        const raw = getSelectedDateValue();
        const isoDate = moment(raw, 'DD / MM / YYYY')
          .tz('Europe/Madrid')
          .format('YYYY-MM-DD');
        const [year, month, day] = isoDate.split('-');
        return { day, month, year };
      })();
    const fecha = {
      ...fechaBase,
      day: ERNI_WIDGET_DEFAULT_DAY,
    };

    const requestToken = createTabRequestToken(targetTab);
    setLoadingForTab(targetTab, true);

    fetchAndRenderErniWidget({
      widgetId: mapping.widget,
      geoId: ERNI_GEOIDS[targetTab],
      fecha,
      targetTab,
      requestToken,
    });
  };

  const tabsReset = (targetTab) => {
    document.querySelectorAll('.tablinkssnp').forEach((tab) => {
      tab.classList.remove('active');
    });
    document.querySelectorAll('.tabcontent').forEach((content) => {
      content.style.display = 'none';
    });

    document
      .querySelector(`.tablinkssnp[data-tab-target="${targetTab}"]`)
      ?.classList.add('active');
    const targetContent = document.getElementById(targetTab);
    if (targetContent) {
      targetContent.style.display = 'block';
    }
  };

  const onChangeLetra = (event) => {
    const clickedTab =
      event?.target?.closest?.('.tablinkssnp') || event?.currentTarget || null;

    if (!clickedTab || clickedTab.style.pointerEvents === 'none') {
      return;
    }

    const targetTab = clickedTab.getAttribute('data-tab-target');
    if (!targetTab) {
      return;
    }

    tabsReset(targetTab);

    const isoDate = moment(getSelectedDateValue(), 'DD / MM / YYYY')
      .tz('Europe/Madrid')
      .format('YYYY-MM-DD');
    const [year, month, day] = isoDate.split('-');

    loadTabById(targetTab, { day, month, year });
  };

  const handlers = {
    onChangeLetra,
  };

  const renderToolbar = () => {
    obToolbar.forEach((element) => {
      componentToolbar.render(element, '.esios-toolbar' + element.id);
    });
  };

  const renderBaseTemplate = () => {
    // Usar siempre la fecha seleccionada (si existe) para que las condiciones
    // de pintado (Melilla/Canary after image) no se reseteen a null en re-renders.
    const datePickerCurrentDate = document.getElementById('datepicker')
      ? moment(
          document.getElementById('datepicker').value,
          'DD / MM / YYYY'
        ).format('YYYY-MM-DD')
      : currentDate;

    templatenoPeninsulares(
      handlers,
      snpData,
      documents,
      snpMoreData,
      titles,
      buttonsState,
      balearNumbers,
      canaryNumbers,
      melillaNumbers,
      ceutaNumbers,
      erniNumbers,
      'all',
      datePickerCurrentDate,
      melillaFormatComparisonDate,
      melillaFormatComparisonDate,
      tenerifeLaGomeraComparisonDate,
      showTenGomLink
    );
  };

  const refreshInfoModals = (shareData) => {
    setInfoModalArr([
      balearNumbers,
      canaryNumbers,
      ceutaNumbers,
      melillaNumbers,
      erniNumbers,
    ]);

    setInfoArr.forEach((el) => {
      const shareModal =
        el.slug === 'erniSNP'
          ? templateShareModal(
              getErniEmbedSlug(),
              getErniShareParams(geoidactual),
              true,
              {
                height: 414,
                width: '100%',
              }
            )
          : templateShareModal(el.slug, shareData);

      setInfoModal(
        el.id,
        el.array,
        {
          slug: el.slug,
          modalText: el.array?.[0]?.description,
        },
        shareModal
      );

      setDateTimeForGeoID(el.slug, el.array);
    });
  };

  const ensureErniDocumentInMoreData = (lang) => {
    if (!Array.isArray(snpMoreData)) {
      snpMoreData = [];
    }

    if (!snpMoreData.some((item) => item.id === 3387)) {
      snpMoreData.push({
        alias: 'ERNI Nudos RR.TT PDBF Fase I',
        display_options: { min: 1, max: 1 },
        id: 3387,
        main: true,
        name: 'ERNI Nudos RR.TT PDBF Fase I',
        serie_type: 'linear',
        short_name: 'ERNI Nudos RR.TT PDBF Fase I',
        url: `${API_URL}/documents/3387/download?locale=${lang}`,
      });
    }
  };

  const loadInitialErniTab = () => {
    tabsReset('TAB1');
    loadTabById('TAB1');
  };

  let preRenderComponent = async () => {
    const state = store.getState();

    document.title = `${i18n.t('non_peninsular_systems')} | ${i18n.t(
      'page_subtitle'
    )}`;

    obToolbar = [
      {
        id: 12,
        slug: i18n.t('routes.baleares'),
        info: true,
        share: true,
        favorite: true,
        analysis: true,
        favId: 12,
        textModal: '',
        url: () =>
          `/${i18n.t('routes.lng')}/${i18n.t(
            'routes.analysis'
          )}/573?compare_indicators=10244,572&start_date=${dateSetTime()}&geoids=8743`,
      },
      {
        id: 13,
        slug: i18n.t('routes.canarias'),
        info: true,
        share: true,
        favorite: true,
        analysis: true,
        favId: 13,
        textModal: '',
        url: () =>
          `/${i18n.t('routes.lng')}/${i18n.t(
            'routes.analysis'
          )}/573?compare_indicators=10243&start_date=${dateSetTime()}&geoids=8742`,
      },
      {
        id: 14,
        slug: i18n.t('routes.ceuta'),
        info: true,
        share: true,
        favorite: true,
        analysis: true,
        favId: 14,
        textModal: '',
        url: () =>
          `/${i18n.t('routes.lng')}/${i18n.t(
            'routes.analysis'
          )}/573?compare_indicators=1347&start_date=${dateSetTime()}&geoids=8744`,
      },
      {
        id: 15,
        slug: i18n.t('routes.melilla'),
        info: true,
        share: true,
        favorite: true,
        analysis: true,
        favId: 15,
        textModal: '',
        url: () =>
          `/${i18n.t('routes.lng')}/${i18n.t(
            'routes.analysis'
          )}/573?compare_indicators=1348&start_date=${dateSetTime()}&geoids=8745`,
      },
      {
        id: 16,
        slug: getErniEmbedSlug(),
        namew: 'ErniSNP',
        info: true,
        share: true,
        favorite: true,
        analysis: true,
        favId: 43,
        params: 'geo_id=8743',
        printParams: 'paramWidgetId=43&widgetType=graph&geo_id=8743',
        textModal: erniModalText,
        url: () => getErniAnalysisUrl(8743),
      },
      {
        id: 17,
        slug: i18n.t('routes.monthly-publication-by-knot-snp'),
        info: true,
        share: false,
        favorite: false,
        analysis: false,
        favId: 49,
        textModal: '',
        url: () => getErniAnalysisUrl(8743),
      },
    ];

    context.name = state.exampleReducer.name;
  };

  let renderComponent = async () => {
    const state = store.getState();
    buttonsState = [
      {
        label: 'see_more_doc',
        url: `/${i18n.t('routes.lng')}/${i18n.t(
          'routes.documentation'
        )}?scope=${i18n.t('routes.non_peninsular_systems')}`,
      },
      {
        label: 'downloads_files',
        url: `/${i18n.t('routes.lng')}/${i18n.t('routes.downloads')}`,
      },
    ];

    try {
      const RapidAccessData = [
        {
          id: '#baleares',
          title: 'Baleares',
        },
        {
          id: '#canarias',
          title: 'Canarias',
        },
        {
          id: '#ceuta',
          title: 'Ceuta',
        },
        {
          id: '#melilla',
          title: 'Melilla',
        },
        {
          id: '#currentNews',
          title: 'more',
        },
      ];
      componentRapidAccess.render(RapidAccessData);

      renderBaseTemplate(buttonsState);
      setTabButtonsLocked(true);

      let inputCalendar = document.querySelector('#datepicker');
      let divCalendar = document.querySelector('.is-day-selectable');

      const queryDate = getDateFromQuery();
      if (queryDate && inputCalendar) {
        inputCalendar.value = queryDate.format('DD / MM / YYYY');
      }

      inputCalendar?.setAttribute('disabled', 'true');
      divCalendar?.classList.add('disabled');

      document
        .querySelector('.esios-layout__wrap')
        .classList.add('esios-layout__wrap--no-peninsulares');

      let dateCurrentTime = document.getElementById('datepicker').value;
      let datetimeFormated = moment(dateCurrentTime, 'DD / MM / YYYY')
        .tz('Europe/Madrid')
        .format('YYYY-MM-DDTHH:mm:ss');

      const initialWidgetsDate =
        (await servicesnoPeninsulares.initialWidgetsDate(
          state.exampleReducer.currentLang
        )) || datetimeFormated;

      modalText = await servicesnoPeninsulares.modalData(
        state.exampleReducer.currentLang,
        15,
        initialWidgetsDate
      );
      snpMoreData = await servicesnoPeninsulares.moreData(
        state.exampleReducer.currentLang,
        16
      );
      ensureErniDocumentInMoreData(state.exampleReducer.currentLang);
      snpData = await servicesnoPeninsulares.init(
        state.exampleReducer.currentLang
      );
      titles = await servicesnoPeninsulares.getTitles(
        state.exampleReducer.currentLang,
        12,
        initialWidgetsDate
      );
      balearNumbers = await servicesnoPeninsulares.dataNumber(
        state.exampleReducer.currentLang,
        12,
        initialWidgetsDate
      );
      canaryNumbers = await servicesnoPeninsulares.dataNumber(
        state.exampleReducer.currentLang,
        13,
        initialWidgetsDate
      );
      ceutaNumbers = await servicesnoPeninsulares.dataNumber(
        state.exampleReducer.currentLang,
        14,
        initialWidgetsDate
      );
      melillaNumbers = await servicesnoPeninsulares.dataNumber(
        state.exampleReducer.currentLang,
        15,
        initialWidgetsDate
      );
      erniNumbers = await servicesnoPeninsulares.dataNumber(
        state.exampleReducer.currentLang,
        43,
        datetimeFormated
      );
      // Activa visualmente TAB1 y pinta su contenido
      const firstTabBtn = document.querySelector(
        'button.tablinkssnp[data-tab-target="TAB1"]'
      );
      if (firstTabBtn) {
        firstTabBtn.classList.add('active');
      }
      document.getElementById('TAB1')?.style &&
        (document.getElementById('TAB1').style.display = 'block');

      // Obtener fechas de comparación antes del render inicial
      try {
        const validUntilDateCeuta =
          await servicesnoPeninsulares.getGeolocalizationDate(8744);
        if (validUntilDateCeuta) {
          melillaFormatComparisonDate =
            moment(validUntilDateCeuta).format('YYYY-MM-DD');
        }
      } catch (e) {
        /* ignorar */
      }
      try {
        const validUntilDateTenerife =
          await servicesnoPeninsulares.getGeolocalizationDate(8797);
        if (validUntilDateTenerife) {
          tenerifeLaGomeraComparisonDate = moment(
            validUntilDateTenerife
          ).format('YYYY-MM-DD');
        }
      } catch (e) {
        /* ignorar */
      }

      // Actualizar la fecha actual para el formato de Melilla
      const updatedCurrentDate = document.getElementById('datepicker')
        ? moment(
            document.getElementById('datepicker').value,
            'DD / MM / YYYY'
          ).format('YYYY-MM-DD')
        : currentDate;

      templatenoPeninsulares(
        handlers,
        snpData,
        documents,
        snpMoreData,
        titles,
        buttonsState,
        balearNumbers,
        canaryNumbers,
        melillaNumbers,
        ceutaNumbers,
        erniNumbers,
        'all',
        updatedCurrentDate,
        melillaFormatComparisonDate,
        melillaFormatComparisonDate,
        tenerifeLaGomeraComparisonDate,
        showTenGomLink
      );
      inputCalendar.removeAttribute('disabled');
      divCalendar.classList.remove('disabled');

      const renderToolbar = () => {
        //Render toolbar
        obToolbar.forEach((element) => {
          componentToolbar.render(element, '.esios-toolbar' + element.id);
        });
      };

      renderToolbar();
      today = new Date();
      const yearref = today.getFullYear();
      const monthref = String(today.getMonth() + 1).padStart(2, '0'); // JavaScript cuenta los meses desde 0, por eso sumamos 1.
      const dayref = String(today.getDate()).padStart(2, '0');
      let currDate = `${dayref}-${monthref}-${yearref}`;
      let monthsAfter = moment(currDate, 'DD-MM-YYYY')
        .subtract(14, 'months')
        .format('DD-MM-YYYY');
      let dayBefore = moment(currDate, 'DD-MM-YYYY')
        .subtract('1', 'day')
        .format('DD-MM-YYYY');
      const analisisElement = document
        .querySelector('.esios-toolbar16 .toolbar-analysis')
        ?.closest('a');
      if (analisisElement) {
        analisisElement.href = buildErniAnalysisUrl(
          monthsAfter,
          currDate,
          geoidactual
        );

        let shareData = window.location.search;
        refreshInfoModals(shareData);

        renderBaseTemplate(buttonsState);
        inputCalendar = document.querySelector('#datepicker');
        divCalendar = document.querySelector('.is-day-selectable');

        inputCalendar?.removeAttribute('disabled');
        divCalendar?.classList.remove('disabled');

        renderToolbar();
        loadInitialErniTab();

        // Carga inicial del widget usando la función común
        // Se verifica inicialmente si Tenerife/La Gomera tiene datos
        loadTabById('TAB9');

        inputCalendar?.addEventListener('change', async function () {
          // quick-lint-js: evita warning de "used before declaration" por shadowing
          // dentro de este handler se re-declaraba targetTab en un scope interior.
          let calendarDiv = document.querySelector('.is-day-selectable');
          inputCalendar.setAttribute('disabled', 'true');
          calendarDiv?.classList.add('disabled');

          balearNumbers = undefined;
          canaryNumbers = undefined;
          ceutaNumbers = undefined;
          melillaNumbers = undefined;
          erniNumbers = undefined;
          renderBaseTemplate(buttonsState);

          // Mostrar spinner y limpiar gráfico del tab activo de inmediato al cambiar fecha.
          const activeTabOnChange =
            document
              .querySelector('.tablinkssnp.active')
              ?.getAttribute('data-tab-target') || 'TAB1';
          const activeMapping = ERNI_TAB_MAPPING[activeTabOnChange];
          if (activeMapping) {
            document
              .getElementById(activeMapping.widget)
              ?.querySelector('svg')
              ?.remove();
          }
          setLoadingForTab(activeTabOnChange, true);

          let newDatetimeFormated = moment(
            inputCalendar.value,
            'DD / MM / YYYY'
          )
            .tz('Europe/Madrid')
            .format();

          modalText = await servicesnoPeninsulares.modalData(
            state.exampleReducer.currentLang,
            15,
            newDatetimeFormated
          );
          balearNumbers = await servicesnoPeninsulares.dataNumber(
            state.exampleReducer.currentLang,
            12,
            newDatetimeFormated
          );
          canaryNumbers = await servicesnoPeninsulares.dataNumber(
            state.exampleReducer.currentLang,
            13,
            newDatetimeFormated
          );
          ceutaNumbers = await servicesnoPeninsulares.dataNumber(
            state.exampleReducer.currentLang,
            14,
            newDatetimeFormated
          );
          melillaNumbers = await servicesnoPeninsulares.dataNumber(
            state.exampleReducer.currentLang,
            15,
            newDatetimeFormated
          );
          erniNumbers = await servicesnoPeninsulares.dataNumber(
            state.exampleReducer.currentLang,
            43,
            newDatetimeFormated
          );

          refreshInfoModals(shareData);
          renderBaseTemplate(buttonsState);
          renderToolbar();

          inputCalendar.removeAttribute('disabled');
          calendarDiv?.classList.remove('disabled');

          const activeButton =
            document.querySelector('.tablinkssnp.active') ||
            document.querySelector('.tablinkssnp[data-tab-target="TAB1"]');
          const targetTab =
            activeButton?.getAttribute('data-tab-target') || 'TAB1';
          const isoDate = moment(inputCalendar.value, 'DD / MM / YYYY')
            .tz('Europe/Madrid')
            .format('YYYY-MM-DD');
          const [year, month, day] = isoDate.split('-');

          try {
            // Si necesitas datos dependientes de fecha:
            const isoFull = moment(inputCalendar.value, 'DD / MM / YYYY')
              .tz('Europe/Madrid')
              .format(); // con hora
            modalText = await servicesnoPeninsulares.modalData(
              state.exampleReducer.currentLang,
              15,
              isoFull
            );
            balearNumbers = await servicesnoPeninsulares.dataNumber(
              state.exampleReducer.currentLang,
              12,
              isoFull
            );
            canaryNumbers = await servicesnoPeninsulares.dataNumber(
              state.exampleReducer.currentLang,
              13,
              isoFull
            );
            ceutaNumbers = await servicesnoPeninsulares.dataNumber(
              state.exampleReducer.currentLang,
              14,
              isoFull
            );
            melillaNumbers = await servicesnoPeninsulares.dataNumber(
              state.exampleReducer.currentLang,
              15,
              isoFull
            );
            erniNumbers = await servicesnoPeninsulares.dataNumber(
              state.exampleReducer.currentLang,
              43,
              isoFull
            );

            // Actualizar la fecha actual del datepicker para el formato de Melilla
            const datePickerCurrentDate = moment(
              inputCalendar.value,
              'DD / MM / YYYY'
            ).format('YYYY-MM-DD');

            // Antes de re-renderizar el template, recalculamos si existe TAB9 (geo 8831)
            // para la fecha seleccionada. Si no hay datos, showTenGomLink=false y el template
            // no debe mostrar el acceso a Tenerife/La Gomera.
            try {
              const widget51Id = ERNI_TAB_MAPPING.TAB9.widget;
              const tenGomData =
                await servicesnoPeninsulares.getErniDataFromWidget({
                  lang: state.exampleReducer.currentLang,
                  globalState: '00:00',
                  ...{ day, month, year },
                  widgetId: widget51Id,
                });

              const indicators8831 = (
                Array.isArray(tenGomData?.indicators)
                  ? tenGomData.indicators
                  : []
              ).filter((ind) => Number(ind?.geo_id) === 8831);

              showTenGomLink = indicators8831.some((indicator) => {
                const indId = Number(indicator?.id);
                if (indId !== 10488) return false;
                const values = Array.isArray(indicator?.values)
                  ? indicator.values
                  : [];
                return values.some((v) => (v?.value ?? v?.y) != null);
              });
            } catch (e) {
              // Si falla la comprobación, por seguridad ocultamos el link para no mostrar una tab rota
              showTenGomLink = false;
            }

            templatenoPeninsulares(
              handlers,
              snpData,
              documents,
              snpMoreData,
              titles,
              buttonsState,
              balearNumbers,
              canaryNumbers,
              melillaNumbers,
              ceutaNumbers,
              erniNumbers,
              'all',
              datePickerCurrentDate,
              melillaFormatComparisonDate,
              melillaFormatComparisonDate,
              tenerifeLaGomeraComparisonDate,
              showTenGomLink
            );

            // Re-renderizar las toolbars después de actualizar el template
            renderToolbar();

            // Redirigir a TAB1 si la tab activa desaparece al cambiar showTenGomLink.
            if (
              (targetTab === 'TAB9' && !showTenGomLink) ||
              ((targetTab === 'TAB4' || targetTab === 'TAB7') && showTenGomLink)
            ) {
              tabsReset('TAB1');
            }

            loadTabById('TAB9', { day, month, year });

            if (targetTab) setLoadingForTab(targetTab, true);
            inputCalendar.removeAttribute('disabled');
            if (divCalendar) divCalendar.classList.remove('disabled');

            setInfoModalArr([
              balearNumbers,
              canaryNumbers,
              ceutaNumbers,
              melillaNumbers,
              erniNumbers,
            ]);
            setInfoArr.forEach((el) => {
              setInfoModal(
                el.id,
                el.array,
                { slug: el.slug, modalText: el.array?.[0]?.description },
                templateShareModal(el.slug, window.location.search),
                'all'
              );
            });

            // Esperar a que el DOM se actualice antes de establecer las fechas
            setTimeout(() => {
              setInfoArr.forEach((el) => {
                setDateTimeForGeoID(el.slug, el.array);
              });
            }, 0);

            // Tab activa (o TAB1 por defecto)
            const activeButtonAfter = document.querySelector(
              '.tablinkssnp.active'
            );
            const targetTabAfter =
              activeButtonAfter?.getAttribute('data-tab-target') || 'TAB1';

            // CARGA pasando la fecha ya normalizada
            const fechaNormalizada = { day, month, year };
            loadTabById(targetTabAfter, fechaNormalizada);
          } catch (error) {
            console.error('Error in calendar change event:', error);
          }
        });

        let newDLArray = {
          renderAgain: (form) => renderComponentDocumentList(form),
          onlyRefresh: () => renderComponentListAgain(),
        };
        componentDocumentList.render(newDLArray, '#document-list-myp');
        renderSuccess = true;
      }
    } catch (error) {
      console.error(error);
      renderSuccess = false;
    }

    let calendar = document.querySelector(
      '.esios-layout__breadcrumbs__calendar-container'
    );
    calendar?.classList.add(
      'esios-layout__breadcrumbs__calendar-container--no-peninsulares'
    );
    document
      .querySelector('.esios-layout__breadcrumbs__wrapper')
      ?.classList.add('esios-layout__breadcrumbs__wrapper--no-peninsulares');
    document
      .querySelector('.esios-layout__breadcrumbs')
      ?.classList.add('esios-layout__breadcrumbs--no-peninsulares');
    document
      .querySelector('.t-max-height')
      ?.classList.add('t-max-height--no-peninsulares');
    const breadcrumbsWrapper = document.querySelector(
      '.esios-layout__breadcrumbs__wrapper'
    );
    if (breadcrumbsWrapper) {
      breadcrumbsWrapper.style.display = 'block';
    }
    document
      .querySelector('.esios-boxdoc__footer')
      ?.classList.add('esios-boxdoc__footer--no-peninsulares');
    document
      .querySelector('#esios-main-page')
      ?.classList.add('esios-main-page--no-peninsulares');

    document
      .querySelector('.esios-market-prices__form')
      ?.classList.add('esios-market-prices__form--no-peninsulares');
    document
      .querySelector('.esios-boxdoc__list')
      ?.classList.add('esios-boxdoc__list--no-peninsulares');
    document
      .querySelector('.row.is-strech')
      ?.classList.add('row.is-strech--no-peninsulares');
    let dateCurrentTime = document.getElementById('datepicker')?.value;
    if (dateCurrentTime && !dateCurrentTime.includes(' ')) {
      let datetimeFormated = moment(dateCurrentTime, 'DD/MM/YYYY')
        .tz('Europe/Madrid')
        .format('DD / MM / YYYY');
      document.getElementById('datepicker').value = datetimeFormated;
    }
  };

  const fixImageMaps = () => {
    const imgs = document.querySelectorAll('img[usemap]');
    imgs.forEach((img) => {
      if (!img.naturalHeight) {
        return;
      }
      const h = img.height / img.naturalHeight;
      const w = img.width / img.naturalWidth;
      const map = document.getElementsByName(img.useMap.slice(1))[0];
      if (!map) {
        return;
      }
      for (let i = 0; i < map.children.length; i++) {
        const area = map.children[i];
        let coords = area.coords;
        if (!area.originalCoords) {
          area.originalCoords = coords;
        } else {
          coords = area.originalCoords;
        }
        const split = coords.split(',');
        let fixed = '';
        split.forEach((coord, n) => {
          if (n !== 0) {
            fixed += ',';
          }
          fixed += n % 2 === 0 ? Number(coord) * w : Number(coord) * h;
        });
        area.coords = fixed;
      }
    });
  };

  window.addEventListener('resize', fixImageMaps, true);
  window.addEventListener('load', fixImageMaps, true);

  let postRenderComponent = () => {
    const state = store.getState();
    context.name = state.exampleReducer.name;
    componentLayoutExtended.render();
  };

  let init = () => {
    preRenderComponent();
    renderComponent();
    renderSuccess ? postRenderComponent() : '';
  };

  let renderComponentDocumentList = async (form) => {
    filterForm.ambit = form.ambit;
    filterForm.action = form.actions;
    filterForm.category = form.category;
    filterForm.process = form.process;
    filterForm.query = form.query;

    let documentListData = await servicesnoPeninsulares.archivesData(
      filterForm
    );

    let newDLArray = {
      isLoading: documentListData.isLoading,
      data: documentListData.newIndicators,
      renderAgain: (newForm) => renderComponentDocumentList(newForm),
      onlyRefresh: () => renderComponentListAgain(),
    };
    componentDocumentList.render(newDLArray, '#document-list-myp');
  };

  let renderComponentListAgain = async () => {
    let newDLArray = {
      renderAgain: (form) => renderComponentDocumentList(form),
      onlyRefresh: () => renderComponentListAgain(),
    };

    componentDocumentList.render(newDLArray, '#document-list-myp');
  };

  return {
    render: init,
  };
})();

export { componentnoPeninsulares };
